import React, { useMemo } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import Detail from './Detail';
import S from './CardStyle.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TagInfoCard(props) {
  const {
    actions,
    keys,
    keysSalesPrice,
    qtyOfTags,
    knowTags
  } = props;
  let taggedKeys = {};
  if (knowTags) {
    taggedKeys = Object.entries(keys).reduce((prev, [key, keyData]) => {
      if (keyData.sell) {
        prev[key] = keyData;
      }
      return prev;
    }, {});
  } else {
    for (let i = 1; i <= qtyOfTags; i++) {
      const tagKey = `Tag ${i}`;
      taggedKeys[tagKey] = {
        tagId: tagKey,
        serialNumber: 'To be Indicated by Consumer'
      };
    }
  }
  const tagLabel = useMemo(() => {
    const numKeys = Object.keys(taggedKeys).length;
    if (qtyOfTags > 1) {
      return `${qtyOfTags} RecovR Tags are being included in this sale.`;
    }
    return '1 RecovR Tag is being included in this sale.';
  }, [taggedKeys]);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "dashboardCard",
    layout: "flex:col",
    className: S.container,
    children: [/*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "keysDataCardUpper",
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          width: 80,
          height: 80,
          alt: "RecovR Tag",
          src: "https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png"
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: tagLabel
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: "Remove any other RecovR Tags from the vehicle's keys before completing the sale."
          })]
        })]
      }), keysSalesPrice != null && /*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "RecovR Tags Sales Price"
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "bodySmallBold",
          children: ["$", keysSalesPrice]
        })]
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      layout: "flex:colL",
      variant: "keysDataCardLower",
      children: Object.entries(taggedKeys).map(([key, value]) => {
        return /*#__PURE__*/_jsx(Detail, {
          label: value.tagNumber || value.tagId,
          value: value.tag?.data?.serialNumber || value?.serialNumber
        }, key);
      })
    })]
  });
}